module.exports = __webpack_public_path__ + "static/media/sudoGPRsix.b87f870f.jpg";